import type { ComponentType } from 'react';
import type { SvgProps } from 'react-native-svg';
import { createTheme as createDSTheme } from 'app/shopify';
const theme = createDSTheme();

export type MinimalSvgProps = Pick<SvgProps, 'color' | 'height' | 'strokeWidth' | 'style' | 'viewBox' | 'width'>;

export type Icon = ComponentType<MinimalSvgProps>;

export function withDefaultIconProps<T extends MinimalSvgProps>(
  defaultValue: Required<Pick<MinimalSvgProps, 'height' | 'width'>> &
    Pick<MinimalSvgProps, 'color'> & { scale?: number },
  Component: ComponentType<T>,
) {
  return function IconWithDefaults({
    color = defaultValue.color ?? theme.colors['text.primary'],
    height = defaultValue.height,
    width = defaultValue.width,
    ...props
  }: Omit<T, 'viewBox'>) {
    const scale = defaultValue.scale ?? 1;
    const scaledHeight = typeof height === 'number' ? height * scale : height;
    const scaledWidth = typeof width === 'number' ? width * scale : width;
    return (
      // @ts-expect-error TypeScript is not playing well with the `T` and `Required<T>` shenanigans.
      <Component
        {...{ color }}
        height={scaledHeight}
        width={scaledWidth}
        viewBox={`0 0 ${defaultValue.width.toString()} ${defaultValue.height.toString()}`}
        {...props}
      />
    );
  };
}
